export const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    gap: 0,
    padding: "8px 0",
    maxWidth: "100%",
    width: "100%",
    margin: "0 auto",
    boxSizing: "border-box",
};
export const otpCssStyles = `
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-4px); }
  40% { transform: translateX(4px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
}
.medos-otp-container {
  display: flex;
  justify-content: center;
  gap: 8px;
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
}
.medos-otp-input {
  flex: 1 1 0;
  min-width: 0;
  max-width: 44px;
  aspect-ratio: 1;
  box-sizing: border-box;
}
@media (max-width: 400px) {
  .medos-otp-container {
    gap: 6px;
    max-width: 280px;
  }
  .medos-otp-input {
    max-width: 40px;
    font-size: 16px !important;
  }
}
@media (max-width: 360px) {
  .medos-otp-container {
    gap: 5px;
    max-width: 260px;
  }
  .medos-otp-input {
    max-width: 38px;
    font-size: 15px !important;
  }
}
@media (max-width: 320px) {
  .medos-otp-container {
    gap: 4px;
    max-width: 240px;
  }
  .medos-otp-input {
    max-width: 34px;
    font-size: 14px !important;
    border-radius: 8px !important;
  }
}
`;
export const getInputStyle = (theme, value, focusedIndex, isError, index) => {
    const isFilled = !!value[index];
    const isFocused = focusedIndex === index;
    const baseStyle = {
        width: "100%",
        height: 44,
        fontSize: 18,
        fontWeight: 600,
        textAlign: "center",
        color: theme.colors.text,
        backgroundColor: theme.colors.background,
        border: `1.5px solid ${theme.colors.border}`,
        borderRadius: 10,
        outline: "none",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        caretColor: theme.colors.primary,
        boxSizing: "border-box",
        padding: 0,
    };
    if (isError) {
        return {
            ...baseStyle,
            borderColor: theme.colors.error,
            backgroundColor: `${theme.colors.error}06`,
            animation: "shake 0.4s ease-in-out",
        };
    }
    if (isFocused) {
        return {
            ...baseStyle,
            borderColor: theme.colors.primary,
            boxShadow: `0 0 0 3px ${theme.colors.primary}20`,
            backgroundColor: theme.colors.surface,
        };
    }
    if (isFilled) {
        return {
            ...baseStyle,
            borderColor: theme.colors.primary,
            backgroundColor: `${theme.colors.primary}06`,
        };
    }
    return baseStyle;
};
